import { gql } from "@apollo/client";

export const CONNECTIONS_LIST = gql`
  subscription($username:jsonb!){
    users_connection(where: {usernames: {_contains: $username}, status: {_eq: 1}}, order_by: {score: desc}) {
      usernames
      id
      score
      sender
      status
      date
    }
  }
`;